import {jsx} from 'panel';

import {PropertyValuesScreenEl} from 'common/widgets/property-filter-menu/property-values-screen';
import {SelectEl} from 'common/components/select';
import {EntryPart} from 'common/widgets/query-entry-section/types';
import {CommitPropertyFilterEvent} from 'common/widgets/property-filter-menu/property-values-screen/types';
import {MappedPropertyValues} from 'common/report/constants';
import {InputEl} from 'common/components/input';
import {InputChangeEvent, InputSize} from 'common/components/input/types';

import {FilterValueProps} from '../types';

export function FilterListValue({
  activeEntry,
  entryPart,
  index,
  filter,
  onSelectMenuChange,
  handleFilterValueChange,
  eventNames,
  projectId,
  workspaceId,
  readOnlyMode,
}: FilterValueProps) {
  const isOpen = activeEntry === index && entryPart === EntryPart.FilterValue;
  const label = filter
    .getLabelParts()
    .slice(2)
    .map((item) => item.label)
    .join(` `);

  /**
   * Historically, list filters are always treated as list of strings, which only
   * require a string input, there is one exception where `Messages Sent` renders
   * a value picker for selecting one of the different messages available in the project
   * we handle that case by rendering `mp-properties-value-screen` for now
   */
  if (filter.propertyName === MappedPropertyValues.Campaigns) {
    return (
      <SelectEl
        class={{
          'is-placeholder': !filter.isValid(),
        }}
        attrs={{
          elref: `filterValueSelect`,
          open: isOpen,
          theme: `select`,
          readonly: readOnlyMode,
          'selected-option': filter.isValid() ? label : `Select value...`,
        }}
        on={{
          menuChange: (ev) => onSelectMenuChange(ev, index, EntryPart.FilterValue),
        }}
      >
        {isOpen && (
          <PropertyValuesScreenEl
            attrs={{
              elref: `filterValue`,
              slot: `body`,
              'display-value-only': true,
              'event-names': eventNames,
              'property-filter': filter.getAttributes(),
              'project-id': projectId,
              'workspace-id': workspaceId,
            }}
            on={{
              commitPropertyFilter: (ev: CommitPropertyFilterEvent) =>
                handleFilterValueChange(ev.detail.propertyFilter.filterValue),
            }}
          />
        )}
      </SelectEl>
    );
  }

  return (
    <InputEl
      class={{'is-placeholder': !filter.isValid()}}
      attrs={{
        elref: `filterInput`,
        placeholder: `value`,
        size: InputSize.Medium,
        'auto-focus': !filter.isValid(),
        'select-on-focus': true,
        readonly: readOnlyMode,
      }}
      props={{value: filter.filterValue as string}}
      on={{
        change: (ev: InputChangeEvent) => {
          const input = ev.target as HTMLInputElement;

          // when the updated value is not a valid input, revert back to previously committed input
          if (ev.detail.value) {
            handleFilterValueChange(ev.detail.value);
          } else {
            input.value = filter.filterValue as string;
          }

          input.blur(); // user has most likely pressed "Enter", in which case they are likely finished so we want to lose focus
        },
      }}
    />
  );
}
